import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';
import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from '@material-ui/core';
import { withStyles, withTheme } from '@material-ui/styles';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import 'moment/locale/it';
import DateFnsUtils from '@date-io/date-fns';
import itLocale from 'date-fns/locale/it';
import OrarioStraordinarioComponent from '../components/OrarioStraordinarioComponent';

const dateFormat = 'dd-MM-yyyy';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContainer: {
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(3, 4),
    borderRadius: 6,
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '90%',
    maxWidth: '900px',
    maxHeight: '90vh',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),

    width: '100%',
  },
  title: {
    width: '100%',
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  formControl: {
    width: '80%',
    maxWidth: '420px',
    minWidth: '240px',
  },
  ricorrenteWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
    width: '100%',
  },
  giornoSpecificoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  chiudiButton: {
    color: theme.palette.text.main,
    margin: '10px',
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
});

class ModalGiorniChiusura extends Component {
  state = {
    periodo: false,
    giornoChiusura: {
      id: null,
      esercizioCommercialeId: this.props.esercizioId,
      dataInizio: moment().toDate(),
      dataFine: null,
      dataSpecifica: null,
      orarioApertura: null,
      orarioChiusura: null,
      interaGiornata: false,
      giorno: null,
      apertura: this.props.apertura,
      ripetizioneSettimanale: null,
      tipo: null,
    },
    validationErrors: {
      dataInizio: '',
      dataFine: '',
      dataSpecifica: '',
      tipo: '',
      giorno: '',
      ripetizioneSettimanale: '',
    },
    giorniEsclusi: [],
  };

  closeModal = () => {
    this.setState({
      giornoChiusura: {
        id: null,
        esercizioCommercialeId: this.props.esercizioId,
        dataInizio: moment().toDate(),
        dataFine: null,
        dataSpecifica: null,
        ripetizioneSettimanale: null,
        apertura: this.props.apertura,
        giorno: null,
        tipo: null,
      },
      giorniEsclusi: [],
    });
    this.props.handleClose();
  };

  saveModal = () => {
    if (this.state.giornoChiusura.orarioApertura === undefined) {
      let giornoChiusuraTemp = this.state.giornoChiusura;
      giornoChiusuraTemp.orarioApertura = null;
      this.setState({
        giornoChiusuraTemp,
      });
    }
    if (this.state.giornoChiusura.orarioChiusura === undefined) {
      let giornoChiusuraTemp = this.state.giornoChiusura;
      giornoChiusuraTemp.orarioChiusura = null;
      this.setState({
        giornoChiusuraTemp,
      });
    }
    if (
      (this.state.giornoChiusura.tipo === 'PERIODO' ||
        this.state.giornoChiusura.tipo === 'RICORRENTE') &&
      this.state.giornoChiusura.dataFine === null
    ) {
      let temp = this.state.giornoChiusura;
      temp.dataFine = moment().toDate();
      this.setState({
        temp,
      });
    }
    if (
      !(
        moment(this.state.giornoChiusura.dataInizio).format() >
        moment(this.state.giornoChiusura.dataFine).format()
      )
    ) {
      if (
        moment(this.state.giornoChiusura.orarioApertura).format('HH:mm:ss') <
          moment(this.state.giornoChiusura.orarioChiusura).format('HH:mm:ss') ||
        this.state.giornoChiusura.orarioApertura === null ||
        this.state.giornoChiusura.orarioChiusura === null
      ) {
        const giorno = {
          id: null,
          esercizioCommercialeId: this.props.esercizioId,
          dataInizio:
            this.state.giornoChiusura.tipo === 'PERIODO' || this.state.periodo
              ? moment(this.state.giornoChiusura.dataInizio)
              : null,
          dataFine:
            this.state.giornoChiusura.tipo === 'PERIODO' || this.state.periodo
              ? moment(this.state.giornoChiusura.dataFine)
              : null,
          dataSpecifica: this.state.giornoChiusura.dataSpecifica,
          ripetizioneSettimanale:
            this.state.giornoChiusura.ripetizioneSettimanale,
          giorno: this.state.giornoChiusura.giorno,
          apertura: this.props.apertura,
          tipo: this.state.giornoChiusura.tipo,
          orarioInizio: this.state.giornoChiusura.orarioApertura
            ? moment(this.state.giornoChiusura.orarioApertura).format('HH:mm')
            : null,
          orarioFine: this.state.giornoChiusura.orarioChiusura
            ? moment(this.state.giornoChiusura.orarioChiusura).format('HH:mm')
            : null,
        };

        let nuoviGiorni = [...this.props.giorniChiusura, giorno];

        this.setState({
          periodo: false,
          giornoChiusura: {
            id: null,
            esercizioCommercialeId: this.props.esercizioId,
            dataInizio: moment().format(),
            dataFine: null,
            dataSpecifica: null,
            ripetizioneSettimanale: null,
            giorno: null,
            tipo: null,
            apertura: this.props.apertura,
            orarioInizio: this.state.giornoChiusura.interaGiornata
              ? null
              : moment(this.state.giornoChiusura.orarioApertura).format(
                  'HH:mm',
                ),
            orarioFine: this.state.giornoChiusura.interaGiornata
              ? null
              : moment(this.state.giornoChiusura.orarioChiusura).format(
                  'HH:mm',
                ),
          },
        });

        this.props.handleComplete();
        this.props.updateGiorniChiusura(nuoviGiorni);
      } else {
        alert('Orario per apertura o chiusura specifica non corretto');
      }
    } else {
      alert(
        'Errore, i valori delle date inserite non sono corretti! Riprovare!',
      );
    }
  };

  onDateTimeChanged = (name, value) => {
    let date = value;
    this.handleChangeTime(name, date);
  };

  handleChangeTime = (name, value) => {
    if (this.state.saveDisabled) {
      this.setState({
        saveDisabled: false,
      });
    }

    let giornoChiusura = this.state.giornoChiusura;
    giornoChiusura[name] = value;

    this.setState({
      giornoChiusura,
    });
    if (
      this.state.giornoChiusura.dataInizio !== null &&
      this.state.giornoChiusura.dataFine !== null
    ) {
      if (
        !this.state.saveButtonEnabled &&
        this.state.giornoChiusura.tipo === 'PERIODO'
      ) {
        this.setState({
          saveButtonEnabled: true,
        });
      }
      if (this.state.saveMessageVisible) {
        this.setState({
          saveMessageVisible: false,
        });
      }
    } else if (this.state.giornoChiusura.dataSpecifica !== null) {
      if (!this.state.saveButtonEnabled) {
        this.setState({
          saveButtonEnabled: true,
        });
      }
      if (this.state.saveMessageVisible) {
        this.setState({
          saveMessageVisible: false,
        });
      }
    }
  };

  handleDataInizio = (data) => {
    let giornoChiusuraTemp = this.state.giornoChiusura;
    giornoChiusuraTemp.dataInizio = data;
    this.setState({
      giornoChiusuraTemp,
    });
    if (this.state.giornoChiusura.tipo === 'PERIODO') {
      this.setState({
        saveButtonEnabled: true,
      });
    }
  };

  handleDataFine = (data) => {
    let giornoChiusuraTemp = this.state.giornoChiusura;
    giornoChiusuraTemp.dataFine = data;
    this.setState({
      giornoChiusuraTemp,
    });
    if (this.state.giornoChiusura.tipo === 'PERIODO') {
      this.setState({
        saveButtonEnabled: true,
      });
    }
  };

  handleOrarioInizio = (orario) => {
    let giornoChiusuraTemp = this.state.giornoChiusura;
    giornoChiusuraTemp.orarioApertura = orario;
    this.setState({
      giornoChiusuraTemp,
    });
  };

  handleOrarioFine = (orario) => {
    let giornoChiusuraTemp = this.state.giornoChiusura;
    giornoChiusuraTemp.orarioChiusura = orario;
    this.setState({
      giornoChiusuraTemp,
    });
  };

  handleInteraGiornata = (data) => {
    let giornoChiusuraTemp = this.state.giornoChiusura;
    giornoChiusuraTemp.interaGiornata = data;
    this.setState({
      giornoChiusuraTemp,
    });
  };

  handleChange = (event) => {
    if (!this.state.saveButtonEnabled && event.target.name === 'giorno') {
      this.setState({
        saveButtonEnabled: true,
      });
    }
    if (this.state.saveMessageVisible) {
      this.setState({
        saveMessageVisible: false,
      });
    }
    let name = event.target.name;
    let value = event.target.value;
    let giornoChiusura = this.state.giornoChiusura;
    giornoChiusura[name] = value;

    this.setState({
      giornoChiusura,
    });
  };

  handleChangeTipo = (event) => {
    this.setState({
      saveButtonEnabled: false,
    });

    let value = event.target.value;
    let giornoChiusura = {
      id: null,
      esercizioCommercialeId: this.props.esercizioId,
      dataInizio: moment().toDate(),
      dataFine: null,
      dataSpecifica: null,
      ripetizioneSettimanale: null,
      giorno: null,
      tipo: value,
      apertura: this.props.apertura ? true : false,
      giorniEsclusi: [],
    };

    this.setState({
      giornoChiusura,
    });
  };

  render() {
    const { classes, theme } = this.props;

    const disabledSubmitbutton =
      this.state.loading ||
      !this.state.saveButtonEnabled ||
      this.state.saveMessageVisible;

    return (
      <Modal
        open={this.props.modal}
        onClose={() => this.closeModal()}
        className={classes.modal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modalContainer}>
          <MuiPickersUtilsProvider
            libInstance={moment}
            utils={MomentUtils}
            locale={'it'}
          >
            <div className={classes.sectionContainer}>
              <Typography variant="h5" className={classes.title}>
                {this.props.apertura
                  ? 'Aggiunta giorno apertura'
                  : 'Aggiunta giorno chiusura'}
              </Typography>
              <div style={{ width: '100%' }}>
                <FormControl className={classes.formControl}>
                  <InputLabel>
                    {this.props.apertura ? 'Tipo apertura' : 'Tipo chiusura'}
                  </InputLabel>
                  <Select
                    value={this.state.giornoChiusura.tipo || ''}
                    name="tipo"
                    onChange={this.handleChangeTipo}
                    fullWidth
                  >
                    <MenuItem value={'RICORRENTE'}>
                      {this.props.apertura
                        ? 'Apertura ricorrente'
                        : 'Chiusura ricorrente'}
                    </MenuItem>
                    <MenuItem value={'PERIODO'}>
                      {this.props.apertura
                        ? 'Periodo apertura'
                        : 'Periodo chiusura'}
                    </MenuItem>
                    <MenuItem value={'SPECIFICO'}>Giorno specifico</MenuItem>
                  </Select>
                </FormControl>
              </div>
              {this.state.giornoChiusura.tipo === 'RICORRENTE' && (
                <div className={classes.ricorrenteWrapper}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <InputLabel>
                      {this.props.apertura
                        ? 'Giorno apertura'
                        : 'Giorno chiusura'}
                    </InputLabel>
                    <Select
                      value={this.state.giornoChiusura.giorno || ''}
                      name="giorno"
                      onChange={this.handleChange}
                    >
                      <MenuItem value={'MONDAY'}>Lunedì</MenuItem>
                      <MenuItem value={'TUESDAY'}>Martedì</MenuItem>
                      <MenuItem value={'WEDNESDAY'}>Mercoledì</MenuItem>
                      <MenuItem value={'THURSDAY'}>Giovedì</MenuItem>
                      <MenuItem value={'FRIDAY'}>Venerdì</MenuItem>
                      <MenuItem value={'SATURDAY'}>Sabato</MenuItem>
                      <MenuItem value={'SUNDAY'}>Domenica</MenuItem>
                    </Select>
                    {this.state.validationErrors.giorno.length > 0 && (
                      <FormHelperText error>
                        {this.state.validationErrors.giorno}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel component="legend">Periodo:</FormLabel>
                    <RadioGroup
                      aria-label="periodo"
                      defaultValue="a"
                      name="radio-buttons-group"
                      row
                    >
                      <FormControlLabel
                        onClick={() => this.setState({ periodo: false })}
                        value={'a'}
                        control={<Radio />}
                        label="Sempre"
                      />
                      <FormControlLabel
                        onClick={() => this.setState({ periodo: true })}
                        value={'b'}
                        control={<Radio />}
                        label="Data intervallo"
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Frequenza settimanale</InputLabel>
                    <Select
                      fullWidth
                      value={
                        this.state.giornoChiusura.ripetizioneSettimanale ?? ''
                      }
                      name="ripetizioneSettimanale"
                      onChange={this.handleChange}
                    >
                      <MenuItem value={0}>Sempre</MenuItem>
                      <MenuItem value={1}>Primo del mese</MenuItem>
                      <MenuItem value={2}>Secondo del mese</MenuItem>
                      <MenuItem value={3}>Terzo del mese</MenuItem>
                      <MenuItem value={4}>Quarto del mese</MenuItem>
                      <MenuItem value={5}>Ultimo del mese</MenuItem>
                    </Select>
                    {this.state.validationErrors.ripetizioneSettimanale.length >
                      0 && (
                      <FormHelperText error>
                        {this.state.validationErrors.ripetizioneSettimanale}
                      </FormHelperText>
                    )}
                  </FormControl>

                  {!this.state.periodo ? (
                    <OrarioStraordinarioComponent
                      mode="ORARIO"
                      handleInteraGiornata={this.handleInteraGiornata}
                      handleDataInizio={this.handleDataInizio}
                      handleDataFine={this.handleDataFine}
                      handleOrarioInizio={this.handleOrarioInizio}
                      handleOrarioFine={this.handleOrarioFine}
                      aperto={this.state.giornoChiusura.apertura}
                    />
                  ) : (
                    <OrarioStraordinarioComponent
                      mode="DATAEORARIO"
                      handleInteraGiornata={this.handleInteraGiornata}
                      handleDataInizio={this.handleDataInizio}
                      handleDataFine={this.handleDataFine}
                      handleOrarioInizio={this.handleOrarioInizio}
                      handleOrarioFine={this.handleOrarioFine}
                      aperto={this.state.giornoChiusura.apertura}
                    />
                  )}
                </div>
              )}
              {this.state.giornoChiusura.tipo === 'PERIODO' && (
                <div>
                  <OrarioStraordinarioComponent
                    mode="PERIODO"
                    dataInizio={this.state.giornoChiusura.dataInizio}
                    handleInteraGiornata={this.handleInteraGiornata}
                    handleDataInizio={this.handleDataInizio}
                    handleDataFine={this.handleDataFine}
                    handleOrarioInizio={this.handleOrarioInizio}
                    handleOrarioFine={this.handleOrarioFine}
                    dataFine={this.state.giornoChiusura.dataFine}
                    aperto={this.state.giornoChiusura.apertura}
                  />
                </div>
              )}
              {this.state.giornoChiusura.tipo === 'SPECIFICO' && (
                <div className={classes.giornoSpecificoWrapper}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={itLocale}
                  >
                    <DatePicker
                      disablePast={true}
                      ampm={false}
                      value={this.state.giornoChiusura.dataSpecifica}
                      onChange={(date) => {
                        this.onDateTimeChanged('dataSpecifica', date);
                      }}
                      format={dateFormat}
                      label="Data"
                      name="dataSpecifica"
                      helperText={this.state.validationErrors.dataSpecifica}
                      error={
                        this.state.validationErrors.dataSpecifica.length > 0
                      }
                    />
                    <OrarioStraordinarioComponent
                      mode="SPECIFICO"
                      handleInteraGiornata={this.handleInteraGiornata}
                      handleDataInizio={this.handleDataInizio}
                      handleDataFine={this.handleDataFine}
                      handleOrarioInizio={this.handleOrarioInizio}
                      handleOrarioFine={this.handleOrarioFine}
                      aperto={this.state.giornoChiusura.apertura}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              )}

              <div className={classes.buttonContainer}>
                <Button
                  type="button"
                  onClick={() => this.closeModal()}
                  variant="contained"
                  size="medium"
                  className={classes.chiudiButton}
                >
                  CHIUDI
                </Button>
                <Button
                  type="button"
                  onClick={() => this.saveModal()}
                  variant="contained"
                  size="medium"
                  disabled={disabledSubmitbutton}
                  style={{
                    color: disabledSubmitbutton
                      ? theme.palette.text.disabled
                      : theme.palette.text.main,
                    margin: '10px',
                    backgroundColor: disabledSubmitbutton
                      ? theme.palette.disabled.main
                      : theme.palette.primary.main,
                  }}
                >
                  AGGIUNGI
                </Button>
              </div>
            </div>
          </MuiPickersUtilsProvider>
        </div>
      </Modal>
    );
  }
}

ModalGiorniChiusura.propTypes = {
  classes: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleComplete: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  modal: PropTypes.bool.isRequired,
  updateGiorniChiusura: PropTypes.func.isRequired,
  esercizioId: PropTypes.number,
  apertura: PropTypes.bool.isRequired,
};

export default withTheme(
  withStyles(styles, { withTheme: true })(ModalGiorniChiusura),
);
